import React from 'react';
import { vars } from '@croquiscom-pvt/zds/tokens';
import styled from '@emotion/styled';

import { Typography } from '@common/styles';
import { numberWithCommas } from '@common/utils';

interface PriceReceiptProps {
  title: string | null;
  title_color?: string;
  price: number;
  price_rate_text?: string;
  price_rate_color?: string;
  price_image_url?: string | null;
  is_sale?: boolean;
}

export const PriceReceipt: React.FC<React.PropsWithChildren<PriceReceiptProps>> = ({
  title,
  title_color,
  price,
  price_rate_text,
  price_rate_color,
  price_image_url,
  is_sale = false,
}) => {
  return (
    <Wrapper className={Typography.BODY_15_MEDIUM}>
      {price_image_url ? <PriceBadge src={price_image_url} /> : <PriceTitle color={title_color}>{title}</PriceTitle>}
      <ValueWrapper>
        <PriceRate color={price_rate_color}>{price_rate_text}</PriceRate>
        <PriceValue color={is_sale ? vars.v3Color.pink400 : vars.v3Color.gray900}>
          {is_sale && '-'}
          {numberWithCommas(price)}원
        </PriceValue>
      </ValueWrapper>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  padding: 0 8px;
  display: flex;
  align-items: center;
  height: 48px;
`;
const PriceBadge = styled.img`
  width: auto;
  height: 18px;
`;

const PriceTitle = styled.div<{ color?: string }>`
  color: ${({ color }) => (color ? color : vars.v3Color.gray400)};
`;

const ValueWrapper = styled.div`
  margin-left: auto;
`;

const PriceRate = styled.span<{ color?: string }>`
  color: ${({ color }) => (color ? color : vars.v3Color.pink400)};
  margin: 0 10px 0 0;
`;
const PriceValue = styled.span<{ color: string }>`
  color: ${({ color }) => (color ? color : vars.v3Color.gray900)};
`;
